import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { config } from '../config';
import UserIcon from "../../../assets/images/user.webp";

const BookingHeader = ({ title, showBack = true, backTo, backLabel }) => {
    const navigate = useNavigate();

    return (
        <div className="booking-page-header">
            {showBack ? (
                <button
                    type="button"
                    className="booking-page-header-back"
                    onClick={() => backTo ? navigate(backTo) : navigate(-1)}
                >
                    <i className="bi bi-arrow-left"></i>
                    {backLabel && <span>{backLabel}</span>}
                </button>
            ) : <div />}
            <div className="booking-page-header-brand">
                <Link to={config.appUrl}>
                    <img src={require("../../../assets/images/Main-logo.png")} alt="Precision Driving School" />
                </Link>
            </div>
            <div className="booking-page-header-user">
                <a href={config.StudentUrl} target="_blank" rel="noreferrer">
                    <i className="bi bi-person-circle"></i>
                </a>
            </div>
        </div>
    );
};

export default BookingHeader;
